<template src="./Shared/template.html" />
<script>
import baseScript from './Shared/script'

export default {
  extends: baseScript
}
</script>
<style lang="scss" module>
@use './Shared/style';

.promotion {
  background-image: url('/images/promotions/jeans-2024.webp');
  background-size: 101% 101%;
  border: 2px solid $grey-lighter;
  container: promotion / inline-size;

  &__inner {
    align-items: center;
    justify-content: center;
  }

  &__row {
    line-height: 0.9;
    -webkit-text-stroke: 2px $white;
    animation: flash 1s infinite;

    &--0 {
      font-size: 14cqw;
      letter-spacing: 1cqw;
    }

    &--1 {
      font-size: 28cqw;
      letter-spacing: 1.5cqw;
    }

  }
}

@keyframes flash {
  0%, 49.999% {
    -webkit-text-stroke: 2px transparent;
    color: $white;
  }

  50%, 99.99% {
    -webkit-text-stroke: 2px $white;
    color: transparent;
  }
}
</style>
